module.exports = __webpack_public_path__ + "static/media/background_especialidad.f14cd9b0.png";